const p = {
  1: "48px",
  2: "64px",
  3: "96px",
  4: "128px",
  5: "160px",
  6: "192px",
  7: "224px",
  8: "288px",
  9: "352px",
  10: "448px",
  100: "100%"
}, x = {
  root: 8
};
export {
  x as s,
  p as w
};
//# sourceMappingURL=encore-sizes-Cg5eTN64.mjs.map
